import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconIdEye02 = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" d="M61.84 28.027a55 55 0 0 0-11.467-9.574L61.04 7.787a2.426 2.426 0 0 0-.133-3.574 2.32 2.32 0 0 0-3.494 0L5.333 56.187a2.666 2.666 0 1 0 3.6 3.6L20 48.72a28.9 28.9 0 0 0 12.293 2.507c11.334 0 22.64-8 29.334-15.467a5.76 5.76 0 0 0 .213-7.733M43.493 35.28a12.24 12.24 0 0 1-8 8c-2.722.867-5.67.686-8.266-.507a.638.638 0 0 1-.16-1.066l14.8-14.827a.667.667 0 0 1 1.093.16 11.47 11.47 0 0 1 .533 8.24M20.293 35.627a.64.64 0 0 0 .187-.64A10.7 10.7 0 0 1 20 32a12.03 12.03 0 0 1 12-12.107c1.05.007 2.091.17 3.093.48a.7.7 0 0 0 .64-.16l5.2-5.2a.694.694 0 0 0-.293-1.12A28.2 28.2 0 0 0 32 12.56c-11.467 0-22.933 8-29.84 15.467a5.76 5.76 0 0 0 0 7.733 57 57 0 0 0 9.147 8 .69.69 0 0 0 .88 0z" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconIdEye02.displayName = 'IconIdEye02';